import { ICON_COPY_LIGHT_GRAY } from 'assets/icons';
import CommonImage from 'components/common/CommonImage';
import Row from 'components/common/Row';
import Text from 'components/common/Text';

interface Props {
  label?: string;
  value: string;
  toastMessage?: string;
}

const ClipboardCopy = ({ label, value, toastMessage }: Props) => {
  return (
    <Row
      onClick={e => {
        e.stopPropagation();

        navigator.clipboard.writeText(value);

        window.showToast(toastMessage ?? '복사되었습니다.', 'success', 3000);
      }}
    >
      <CommonImage src={ICON_COPY_LIGHT_GRAY} style={{ marginLeft: '4px' }} />
      <Text size="10px" weight={400}>
        {label ? label : '복사'}
      </Text>
    </Row>
  );
};

export default ClipboardCopy;
